import { CURRENT_DONE } from "@/steps";

export const STALE_DAYS = 14;

const DAY = 86400000;

export function blockedDays(blockedSince, now = Date.now()) {
  if (!blockedSince) return null;
  const timestamp = Date.parse(blockedSince);
  if (Number.isNaN(timestamp)) return null;
  return Math.max(0, Math.floor((now - timestamp) / DAY));
}

function createdAt(client) {
  return Date.parse(client.created_at || "") || 0;
}

function rank(client) {
  const steps = client.steps || {};
  if (steps.current === CURRENT_DONE) return 2;
  return steps.blocked_since ? 0 : 1;
}

export function sortClients(clients, now = Date.now()) {
  return [...clients].sort((left, right) => {
    const leftRank = rank(left);
    const rightRank = rank(right);
    if (leftRank !== rightRank) return leftRank - rightRank;

    if (leftRank === 0) {
      const blockedDifference =
        blockedDays(right.steps.blocked_since, now) - blockedDays(left.steps.blocked_since, now);
      if (blockedDifference !== 0) return blockedDifference;
    }

    return createdAt(right) - createdAt(left);
  });
}

export function filterClients(clients, { waitingOn = "all" } = {}) {
  if (waitingOn === "all") return clients;
  return clients.filter((client) => client.steps?.waiting_on === waitingOn);
}

export function handOwner(client, usersById = {}) {
  const steps = client.steps || {};
  if (!steps.current || steps.current === CURRENT_DONE) return "—";
  if (steps.waiting_on === "client") return "le client";
  const owner = client.owner_id ? usersById[client.owner_id] : null;
  return owner?.name || "—";
}

export function sharedNames(client, usersById = {}) {
  return (client.shared_with || [])
    .map((userId) => usersById[userId]?.name)
    .filter(Boolean);
}
